const actions = {
  SET_STATE: 'setting/SET_STATE',
  FETCH_SETTING: 'setting/FETCH_SETTING',
  UPDATE_SETTING: 'setting/UPDATE_SETTING',
  REFRESH_ERRORS: 'user/REFRESH_ERRORS'
};

export default actions
